<template>
  <div>
    <el-row type="flex" justify="space-between">
      <el-col :span="24">
        <div :class="gridsize">
          <ag-grid-vue
            style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
            class="ag-theme-balham"
            rowSelection="single"
            :defaultColDef="defaultColDef"
            :columnDefs="errorPaymentsColumnDefs"
            :rowData="paymentErrors"
            :gridOptions="errorPaymentsGridOptions"
            @grid-ready="onPaymentErrorsGridReady"
            @first-data-rendered="onFirstPaymentErrorsDataRendered"
            @modelUpdated="onErrorPaymentsModelUpdated"
            @rowSelected="onErrorPaymentsRowSelected"
            @rowDoubleClicked="onErrorPaymentsRowDoubleClicked"
            @cellContextMenu="onPaymentErrorsRowRightClicked"
          ></ag-grid-vue>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" justify="space-between" style="margin-top: 10px;">
      <el-col :span="24">
        <el-checkbox
          v-model="autoDistributeCheckbox"
          v-shortkey="{ F2: ['f2'] }"
          @shortkey.native="onShortKeyRouter"
          style="margin-left: 0em"
        >
          {{ $t("errorPayments.errorPaymentsForm.autoDistribute") }}
        </el-checkbox>
      </el-col>
    </el-row>
    <el-row type="flex" justify="space-between" style="margin-top: 10px">
      <el-col :span="18" style="text-align:left;">
        <el-button
          type="primary"
          size="small"
          @click="onClickErrorPaymentChangeBtn('edit')"
          :disabled="fixBtnDisabled"
          v-shortkey="{ Enter: ['enter'], F4: ['f4'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">F4</span
          >{{ $t("common.buttons.fix") }}</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="onClickErrorPaymentChangeBtn('del')"
          :disabled="removeBtnDisabled"
          v-shortkey="{ Del: ['del'], Minus: ['-'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">Del</span
          >{{ $t("common.buttons.remove") }}</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="onClickErrorPaymentDistributeBtn"
          :disabled="distributeBtnDisabled"
          v-shortkey="{ F9: ['f9'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">F9</span
          >{{ $t("common.buttons.distribute") }}</el-button
        >
      </el-col>
      <el-col :span="6" style="text-align:right;">
        <el-button
          type="primary"
          size="small"
          v-if="typeForm === 'page'"
          @click="searchErrorPaymentsModal = true"
          v-shortkey="{ F7: ['f7'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">F7</span
          >{{ $t("common.buttons.searchPayments") }}</el-button
        >
      </el-col>
    </el-row>

    <el-dialog
      :title="$t('relationship.searchErrorPaymentsForm.modal.title')"
      :visible.sync="searchErrorPaymentsModal"
      :close-on-click-modal="false"
      @open="searchErrorPaymentsModalShow"
      @close="searchErrorPaymentsModalHide"
      width="55%"
      top="1em"
      v-draggable
    >
      <div class="more-info__inner" ref="searchErrorPayments">
        <el-form
          :model="searchErrorPaymentsForm"
          :rules="searchErrorPaymentsRules"
          ref="searchErrorPaymentsForm"
        >
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{ $t("relationship.searchErrorPaymentsForm.form.abcode") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item>
                <el-input
                  v-model="searchErrorPaymentsForm.abcode"
                  clearable
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-select
                  v-model="searchErrorPaymentsForm.abcodeTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{ $t("relationship.searchErrorPaymentsForm.form.sumPay") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <el-select
                  v-model="searchErrorPaymentsForm.sumPayTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchDateTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="sumPayBegin">
                <currency-input
                  placeholder="0.00"
                  v-model.lazy="searchErrorPaymentsForm.sumPayBegin"
                  class="el-input--small el-input__inner"
                  style="width: 100%; height: 32px; line-height: 32px;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item
                v-if="searchErrorPaymentsForm.sumPayTypeSearch === '1'"
              >
                <div style="text-align: center;">
                  {{ $t("relationship.searchErrorPaymentsForm.form.and") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                prop="sumPayEnd"
                v-if="searchErrorPaymentsForm.sumPayTypeSearch === '1'"
              >
                <currency-input
                  placeholder="0.00"
                  v-model.lazy="searchErrorPaymentsForm.sumPayEnd"
                  class="el-input--small el-input__inner"
                  style="width: 100%; height: 32px; line-height: 32px;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{ $t("relationship.searchErrorPaymentsForm.form.dateBank") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <el-select
                  v-model="searchErrorPaymentsForm.dateBankTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchDateTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="dateBankBegin">
                <el-date-picker
                  v-model="searchErrorPaymentsForm.dateBankBegin"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item
                v-if="searchErrorPaymentsForm.dateBankTypeSearch === '1'"
              >
                <div style="text-align: center;">
                  {{ $t("relationship.searchErrorPaymentsForm.form.and") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                prop="dateBankEnd"
                v-if="searchErrorPaymentsForm.dateBankTypeSearch === '1'"
              >
                <el-date-picker
                  v-model="searchErrorPaymentsForm.dateBankEnd"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{ $t("relationship.searchErrorPaymentsForm.form.datePay") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <el-select
                  v-model="searchErrorPaymentsForm.datePayTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchDateTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="datePayBegin">
                <el-date-picker
                  v-model="searchErrorPaymentsForm.datePayBegin"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item
                v-if="searchErrorPaymentsForm.datePayTypeSearch === '1'"
              >
                <div style="text-align: center;">
                  {{ $t("relationship.searchErrorPaymentsForm.form.and") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                prop="datePayEnd"
                v-if="searchErrorPaymentsForm.datePayTypeSearch === '1'"
              >
                <el-date-picker
                  v-model="searchErrorPaymentsForm.datePayEnd"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{
                    $t("relationship.searchErrorPaymentsForm.form.dateChange")
                  }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <el-select
                  v-model="searchErrorPaymentsForm.dateChangeTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchDateTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="dateChangeBegin">
                <el-date-picker
                  v-model="searchErrorPaymentsForm.dateChangeBegin"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item
                v-if="searchErrorPaymentsForm.dateChangeTypeSearch === '1'"
              >
                <div style="text-align: center;">
                  {{ $t("relationship.searchErrorPaymentsForm.form.and") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                prop="dateChangeEnd"
                v-if="searchErrorPaymentsForm.dateChangeTypeSearch === '1'"
              >
                <el-date-picker
                  v-model="searchErrorPaymentsForm.dateChangeEnd"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{
                    $t("relationship.searchErrorPaymentsForm.form.errorType")
                  }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="19">
              <el-form-item>
                <el-select
                  v-model="searchErrorPaymentsForm.errorType"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  clearable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in params.statuspay.data"
                    :key="item.coderr"
                    :label="item.nameerr"
                    :value="item.coderr"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div v-if="extendedSearch">
            <el-divider></el-divider>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{ $t("relationship.searchErrorPaymentsForm.form.npack") }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item>
                  <el-input-number
                    v-model.lazy="searchErrorPaymentsForm.npack"
                    :precision="0"
                    :controls="false"
                    style="width: 100%;"
                    size="small"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item> </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{
                      $t(
                        "relationship.searchErrorPaymentsForm.form.datePayFrom"
                      )
                    }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item prop="datePayFrom">
                  <el-date-picker
                    v-model="searchErrorPaymentsForm.datePayFrom"
                    type="date"
                    :placeholder="
                      $t('common.components.datePicker.placeholder')
                    "
                    format="dd.MM.yyyy"
                    value-format="dd.MM.yyyy"
                    :picker-options="pickerOptions"
                    size="small"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="1" style="text-align:right;">
                <el-form-item>
                  <div>
                    {{
                      $t("relationship.searchErrorPaymentsForm.form.datePayTo")
                    }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item prop="datePayTo">
                  <el-date-picker
                    v-model="searchErrorPaymentsForm.datePayTo"
                    type="date"
                    :placeholder="
                      $t('common.components.datePicker.placeholder')
                    "
                    format="dd.MM.yyyy"
                    value-format="dd.MM.yyyy"
                    :picker-options="pickerOptions"
                    size="small"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{
                      $t("relationship.searchErrorPaymentsForm.form.kindpay")
                    }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="19">
                <el-form-item>
                  <el-select
                    v-model="searchErrorPaymentsForm.kindpay"
                    :placeholder="$t('common.components.select.placeholder')"
                    filterable
                    clearable
                    size="small"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in params.gkindpay.data"
                      :key="item.kindpay"
                      :label="item.kindname"
                      :value="item.kindpay"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{
                      $t("relationship.searchErrorPaymentsForm.form.codefirme")
                    }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="19">
                <el-form-item>
                  <el-select
                    v-model="searchErrorPaymentsForm.codefirme"
                    :placeholder="$t('common.components.select.placeholder')"
                    filterable
                    clearable
                    size="small"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in params.gfirme.data"
                      :key="item.codefirme"
                      :label="item.namefirme"
                      :value="item.codefirme"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{ $t("relationship.searchErrorPaymentsForm.form.note") }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item>
                  <el-input
                    v-model="searchErrorPaymentsForm.note"
                    clearable
                    size="small"
                    style="width: 100%;"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-select
                    v-model="searchErrorPaymentsForm.noteTypeSearch"
                    :placeholder="$t('common.components.select.placeholder')"
                    filterable
                    size="small"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in searchTypesOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="12" style="text-align:left;">
            <el-checkbox
              v-model="extendedSearch"
              v-shortkey="{ F2: ['f2'] }"
              @shortkey.native="onShortKeyRouter"
              >{{
                $t("relationship.searchErrorPaymentsForm.extendedSearch")
              }}</el-checkbox
            >
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="searchErrorPaymentsFormSubmit"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.submit") }}</el-button
            >
            <el-button
              type="plain"
              size="small"
              @click="searchErrorPaymentsModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <Payment></Payment>
  </div>
</template>

<script>
import { sortSum, formatSum } from "@/helpers/reference";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
import { $, gt, lt } from "moneysafe";
import Payment from "@/components/Payment";
import { setGridView } from "@/helpers/grid";
import { pickerOptions } from "@/mixins/pickerOptions";
import { dialogWidth } from "@/mixins/dialogWidth";
import { checkAccess } from "@/helpers/access";

export default {
  name: "errors",
  props: ["typeForm"],
  components: {
    AgGridVue,
    Payment
  },
  mixins: [pickerOptions, dialogWidth],
  data() {
    const validateSumPayBegin = (rule, value, callback) => {
      const sumChangeDiff = gt(
        $(this.searchErrorPaymentsForm.sumPayBegin),
        $(this.searchErrorPaymentsForm.sumPayEnd)
      );
      const sumFormType =
        this.searchErrorPaymentsForm.sumPayTypeSearch === "1" ? true : false;

      if (sumFormType && value && sumChangeDiff) {
        callback(new Error(this.$t("common.validations.sumBegin.beginGtEnd")));
      } else if (
        sumFormType &&
        value &&
        !this.searchErrorPaymentsForm.sumPayEnd
      ) {
        callback(new Error(this.$t("common.validations.sumBegin.endSumEmpty")));
      } else {
        callback();
      }
    };
    const validateSumPayEnd = (rule, value, callback) => {
      const sumChangeDiff = lt(
        $(this.searchErrorPaymentsForm.sumPayEnd),
        $(this.searchErrorPaymentsForm.sumPayBegin)
      );
      const sumFormType =
        this.searchErrorPaymentsForm.sumPayTypeSearch === "1" ? true : false;

      if (sumFormType && value && sumChangeDiff) {
        callback(new Error(this.$t("common.validations.sumEnd.endLtBegin")));
      } else if (
        sumFormType &&
        value &&
        !this.searchErrorPaymentsForm.sumPayBegin
      ) {
        callback(new Error(this.$t("common.validations.sumEnd.beginSumEmpty")));
      } else {
        callback();
      }
    };
    const validateDateBankBegin = (rule, value, callback) => {
      const dateBankBegin = this.$moment(
        this.searchErrorPaymentsForm.dateBankBegin,
        "DD.MM.YYYY"
      );
      const dateBankEnd = this.$moment(
        this.searchErrorPaymentsForm.dateBankEnd,
        "DD.MM.YYYY"
      );
      const dateChangeDiff = this.$moment(dateBankBegin).isAfter(dateBankEnd);
      const dateFormType =
        this.searchErrorPaymentsForm.dateBankTypeSearch === "1" ? true : false;

      if (dateFormType && value && dateChangeDiff) {
        callback(
          new Error(this.$t("common.validations.dateBegin.beginIsAfterEnd"))
        );
      } else if (dateFormType && value && !dateBankEnd._isValid) {
        callback(
          new Error(this.$t("common.validations.dateBegin.endDateEmpty"))
        );
      } else {
        callback();
      }
    };
    const validateDateBankEnd = (rule, value, callback) => {
      const dateBankBegin = this.$moment(
        this.searchErrorPaymentsForm.dateBankBegin,
        "DD.MM.YYYY"
      );
      const dateBankEnd = this.$moment(
        this.searchErrorPaymentsForm.dateBankEnd,
        "DD.MM.YYYY"
      );
      const dateChangeDiff = this.$moment(dateBankEnd).isBefore(dateBankBegin);
      const dateFormType =
        this.searchErrorPaymentsForm.dateBankTypeSearch === "1" ? true : false;

      if (dateFormType && value && dateChangeDiff) {
        callback(
          new Error(this.$t("common.validations.dateEnd.endIsBeforeBegin"))
        );
      } else if (dateFormType && value && !dateBankBegin._isValid) {
        callback(
          new Error(this.$t("common.validations.dateEnd.beginDateEmpty"))
        );
      } else {
        callback();
      }
    };
    const validateDatePayBegin = (rule, value, callback) => {
      const datePayBegin = this.$moment(
        this.searchErrorPaymentsForm.datePayBegin,
        "DD.MM.YYYY"
      );
      const datePayEnd = this.$moment(
        this.searchErrorPaymentsForm.datePayEnd,
        "DD.MM.YYYY"
      );
      const dateChangeDiff = this.$moment(datePayBegin).isAfter(datePayEnd);
      const dateFormType =
        this.searchErrorPaymentsForm.datePayTypeSearch === "1" ? true : false;

      if (dateFormType && value && dateChangeDiff) {
        callback(
          new Error(this.$t("common.validations.dateBegin.beginIsAfterEnd"))
        );
      } else if (dateFormType && value && !datePayEnd._isValid) {
        callback(
          new Error(this.$t("common.validations.dateBegin.endDateEmpty"))
        );
      } else {
        callback();
      }
    };
    const validateDatePayEnd = (rule, value, callback) => {
      const datePayBegin = this.$moment(
        this.searchErrorPaymentsForm.datePayBegin,
        "DD.MM.YYYY"
      );
      const datePayEnd = this.$moment(
        this.searchErrorPaymentsForm.datePayEnd,
        "DD.MM.YYYY"
      );
      const dateChangeDiff = this.$moment(datePayEnd).isBefore(datePayBegin);
      const dateFormType =
        this.searchErrorPaymentsForm.datePayTypeSearch === "1" ? true : false;

      if (dateFormType && value && dateChangeDiff) {
        callback(
          new Error(this.$t("common.validations.dateEnd.endIsBeforeBegin"))
        );
      } else if (dateFormType && value && !datePayBegin._isValid) {
        callback(
          new Error(this.$t("common.validations.dateEnd.beginDateEmpty"))
        );
      } else {
        callback();
      }
    };
    const validateDateChangeBegin = (rule, value, callback) => {
      const dateChangeBegin = this.$moment(
        this.searchErrorPaymentsForm.dateChangeBegin,
        "DD.MM.YYYY"
      );
      const dateChangeEnd = this.$moment(
        this.searchErrorPaymentsForm.dateChangeEnd,
        "DD.MM.YYYY"
      );
      const dateChangeDiff = this.$moment(dateChangeBegin).isAfter(
        dateChangeEnd
      );
      const dateFormType =
        this.searchErrorPaymentsForm.dateChangeTypeSearch === "1"
          ? true
          : false;

      if (dateFormType && value && dateChangeDiff) {
        callback(
          new Error(this.$t("common.validations.dateBegin.beginIsAfterEnd"))
        );
      } else if (dateFormType && value && !dateChangeEnd._isValid) {
        callback(
          new Error(this.$t("common.validations.dateBegin.endDateEmpty"))
        );
      } else {
        callback();
      }
    };
    const validateDateChangeEnd = (rule, value, callback) => {
      const dateChangeBegin = this.$moment(
        this.searchErrorPaymentsForm.dateChangeBegin,
        "DD.MM.YYYY"
      );
      const dateChangeEnd = this.$moment(
        this.searchErrorPaymentsForm.dateChangeEnd,
        "DD.MM.YYYY"
      );
      const dateChangeDiff = this.$moment(dateChangeEnd).isBefore(
        dateChangeBegin
      );
      const dateFormType =
        this.searchErrorPaymentsForm.dateChangeTypeSearch === "1"
          ? true
          : false;

      if (dateFormType && value && dateChangeDiff) {
        callback(
          new Error(this.$t("common.validations.dateEnd.endIsBeforeBegin"))
        );
      } else if (dateFormType && value && !dateChangeBegin._isValid) {
        callback(
          new Error(this.$t("common.validations.dateEnd.beginDateEmpty"))
        );
      } else {
        callback();
      }
    };
    const validateDatePayFrom = (rule, value, callback) => {
      const datePayFrom = this.$moment(
        this.searchErrorPaymentsForm.datePayFrom,
        "DD.MM.YYYY"
      );
      const datePayTo = this.$moment(
        this.searchErrorPaymentsForm.datePayTo,
        "DD.MM.YYYY"
      );
      const datePayDiff = this.$moment(datePayFrom).isAfter(datePayTo);

      if (value && datePayDiff) {
        callback(
          new Error(this.$t("common.validations.dateBegin.beginIsAfterEnd"))
        );
      } else if (value && !datePayTo._isValid) {
        callback(
          new Error(this.$t("common.validations.dateBegin.endDateEmpty"))
        );
      } else {
        callback();
      }
    };
    const validateDatePayTo = (rule, value, callback) => {
      const datePayFrom = this.$moment(
        this.searchErrorPaymentsForm.datePayFrom,
        "DD.MM.YYYY"
      );
      const datePayTo = this.$moment(
        this.searchErrorPaymentsForm.datePayTo,
        "DD.MM.YYYY"
      );
      const datePayDiff = this.$moment(datePayTo).isBefore(datePayFrom);

      if (value && datePayDiff) {
        callback(
          new Error(this.$t("common.validations.dateEnd.endIsBeforeBegin"))
        );
      } else if (value && !datePayFrom._isValid) {
        callback(
          new Error(this.$t("common.validations.dateEnd.beginDateEmpty"))
        );
      } else {
        callback();
      }
    };
    return {
      agGridlocaleText: null,
      errorPaymentsGridOptions: null,
      errorPaymentsGridApi: null,
      errorPaymentsColumnApi: null,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        autoHeight: false,
        filterParams: {
          applyButton: false,
          clearButton: true
        },
        headerClass: "ag-grid-header",
        cellClass: "ag-grid-cell"
      },
      errorPaymentsColumnDefs: [
        {
          headerName: this.$t("common.gridColumns.payment"),
          headerTooltip: this.$t("common.gridColumns.payment"),
          children: [
            {
              headerName: this.$t("common.gridColumns.abcodeLong"),
              headerTooltip: this.$t("common.gridColumns.abcodeLong"),
              field: "abcode",
              tooltipField: "abcode",
              cellClass: "reporting-month"
            },
            {
              headerName: this.$t("common.gridColumns.error"),
              headerTooltip: this.$t("common.gridColumns.error"),
              field: "errorname",
              tooltipField: "errorname"
            },
            {
              headerName: this.$t("common.gridColumns.kindname"),
              headerTooltip: this.$t("common.gridColumns.kindname"),
              field: "kindname",
              tooltipField: "kindname"
            },
            {
              headerName: this.$t("common.gridColumns.npack"),
              headerTooltip: this.$t("common.gridColumns.npack"),
              field: "npack",
              tooltipField: "npack"
            },
            {
              headerName: this.$t("common.gridColumns.sumorig"),
              headerTooltip: this.$t("common.gridColumns.sumorig"),
              field: "sumorig",
              tooltipField: "sumorig",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.currencyname"),
              headerTooltip: this.$t("common.gridColumns.currencyname"),
              field: "currencyname",
              tooltipField: "currencyname"
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summpay",
              tooltipField: "summpay",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.datepay"),
              headerTooltip: this.$t("common.gridColumns.datepay"),
              field: "dateclient",
              tooltipField: "dateclient",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.datebank"),
              headerTooltip: this.$t("common.gridColumns.datebank"),
              field: "datebank",
              tooltipField: "datebank",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.bank"),
              headerTooltip: this.$t("common.gridColumns.bank"),
              field: "namefirme",
              tooltipField: "namefirme"
            },
            {
              headerName: this.$t("common.gridColumns.payname"),
              headerTooltip: this.$t("common.gridColumns.payname"),
              field: "payname",
              tooltipField: "payname"
            },
            {
              headerName: this.$t("common.gridColumns.mess"),
              headerTooltip: this.$t("common.gridColumns.mess"),
              field: "prim",
              tooltipField: "prim",
              cellClass: "reporting-month"
            }
          ]
        },
        {
          headerName: this.$t("common.gridColumns.validity"),
          headerTooltip: this.$t("common.gridColumns.validity"),
          children: [
            {
              headerName: this.$t("common.gridColumns.datebegin"),
              headerTooltip: this.$t("common.gridColumns.datebegin"),
              field: "datebegin",
              tooltipField: "datebegin",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.dateend"),
              headerTooltip: this.$t("common.gridColumns.dateend"),
              field: "dateend",
              tooltipField: "dateend",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            }
          ]
        },
        {
          headerName: this.$t("common.gridColumns.makingEntry"),
          headerTooltip: this.$t("common.gridColumns.makingEntry"),
          children: [
            {
              headerName: this.$t("common.gridColumns.datebeginfact"),
              headerTooltip: this.$t("common.gridColumns.datebeginfact"),
              field: "datebeginfact",
              tooltipField: "datebeginfact",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.username"),
              headerTooltip: this.$t("common.gridColumns.username"),
              field: "username",
              tooltipField: "username",
              cellClass: "reporting-month"
            }
          ]
        }
      ],
      gridsize: "",
      currentErrorPaymentRowSelected: null,
      fixBtnDisabled: true,
      removeBtnDisabled: true,
      distributeBtnDisabled: true,
      autoDistributeCheckbox: false,
      paymentErrorsLastRow: null,

      // модальное окно Поиск ошибочного платежа
      searchErrorPaymentsModal: false,
      searchErrorPaymentsForm: {
        abcode: "",
        abcodeTypeSearch: "1",
        sumPayBegin: 0,
        sumPayEnd: 0,
        sumPayTypeSearch: "0",
        dateBankBegin: "",
        dateBankEnd: "",
        dateBankTypeSearch: "0",
        datePayBegin: "",
        datePayEnd: "",
        datePayTypeSearch: "0",
        dateChangeBegin: "",
        dateChangeEnd: "",
        dateChangeTypeSearch: "0",
        errorType: null,
        npack: null,
        datePayFrom: "",
        datePayTo: "",
        kindpay: null,
        codefirme: null,
        note: "",
        noteTypeSearch: "1"
      },
      searchErrorPaymentsRules: {
        sumPayBegin: [
          {
            required: true,
            validator: validateSumPayBegin,
            trigger: "blur"
          }
        ],
        sumPayEnd: [
          {
            required: true,
            validator: validateSumPayEnd,
            trigger: "blur"
          }
        ],
        dateBankBegin: [
          {
            required: true,
            validator: validateDateBankBegin,
            trigger: "blur"
          }
        ],
        dateBankEnd: [
          {
            required: true,
            validator: validateDateBankEnd,
            trigger: "blur"
          }
        ],
        datePayBegin: [
          {
            required: true,
            validator: validateDatePayBegin,
            trigger: "blur"
          }
        ],
        datePayEnd: [
          {
            required: true,
            validator: validateDatePayEnd,
            trigger: "blur"
          }
        ],
        dateChangeBegin: [
          {
            required: true,
            validator: validateDateChangeBegin,
            trigger: "blur"
          }
        ],
        dateChangeEnd: [
          {
            required: true,
            validator: validateDateChangeEnd,
            trigger: "blur"
          }
        ],
        datePayFrom: [
          {
            required: true,
            validator: validateDatePayFrom,
            trigger: "blur"
          }
        ],
        datePayTo: [
          {
            required: true,
            validator: validateDatePayTo,
            trigger: "blur"
          }
        ]
      },
      extendedSearch: false,
      searchTypesOptions: [
        {
          value: "0",
          label: this.$t("common.options.searchTypes.matches")
        },
        {
          value: "1",
          label: this.$t("common.options.searchTypes.contains")
        },
        {
          value: "2",
          label: this.$t("common.options.searchTypes.startsOn")
        },
        {
          value: "3",
          label: this.$t("common.options.searchTypes.endsOn")
        }
      ],
      searchDateTypesOptions: [
        {
          value: "0",
          label: this.$t("common.options.searchDateTypes.equal")
        },
        {
          value: "1",
          label: this.$t("common.options.searchDateTypes.between")
        }
      ]
    };
  },
  created() {
    this.gridsize =
      this.typeForm === "page"
        ? "grid-errors-container-view"
        : "grid-errors-container-modal";

    window.addEventListener("resize", this.onResize);
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }

    this.errorPaymentsGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText,
      rowClassRules: {
        "ag-state-delivered": params => params.data.coderr === "0"
      }
    };
  },
  mounted() {
    if (this.typeForm === "page") this.searchErrorPaymentsModal = true;
  },
  beforeDestroy() {
    this.clearPaymentErrors();

    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    ...mapGetters([
      "paymentErrors",
      "paymentPostingError",
      "paymentRefreshErrors",
      "params"
    ])
  },
  watch: {
    paymentPostingError: function(value) {
      if (value) {
        this.$alert(value.message, "", {
          confirmButtonText: "OK",
          type: value.type,
          callback: () => {
            this.getErrorPayments();
          }
        });
      }
    },
    paymentRefreshErrors: function(value) {
      if (value) {
        this.$store.commit("setPaymentRefreshErrors", null);

        if (
          value.type === "edit" &&
          value.statusPay === "0" &&
          this.autoDistributeCheckbox
        ) {
          const payid = value.newPayId;
          this.clearPaymentPostingError();
          this.$store.dispatch("paymentPostingError", { payid });
        } else {
          this.paymentErrorsLastRow = value.newPayId;
          this.getErrorPayments();
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      "setGridContextMenuModal",
      "setGridContextMenuKey",
      "setGridContextMenuEvent",
      "setPaymentData",
      "setPaymentModal",
      "clearPaymentErrors",
      "clearPaymentPostingError"
    ]),
    ...mapActions(["getPaymentErrors"]),
    onPaymentErrorsGridReady(params) {
      this.errorPaymentsGridApi = params.api;
      this.errorPaymentsColumnApi = params.columnApi;
    },
    onFirstPaymentErrorsDataRendered(event) {
      setGridView("wb-errors-grid-paymenterrors", event, "full");
    },
    onPaymentErrorsRowRightClicked(event) {
      this.setGridContextMenuKey("wb-errors-grid-paymenterrors");
      this.setGridContextMenuEvent(event);
      this.setGridContextMenuModal(true);
    },
    onErrorPaymentsModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();
      if (rowCount === 0) {
        this.fixBtnDisabled = true;
        this.removeBtnDisabled = true;
        this.distributeBtnDisabled = true;
      } else {
        this.fixBtnDisabled = false;
        this.removeBtnDisabled = checkAccess(45) ? false : true;
        this.distributeBtnDisabled = true;

        params.api.forEachNode(node => {
          if (node.data.payid === this.paymentErrorsLastRow) {
            node.setSelected(true);
            params.api.ensureIndexVisible(node.rowIndex);
          } else {
            node.rowIndex ? 0 : node.setSelected(true);
          }
        });
      }
    },
    onErrorPaymentsRowSelected(params) {
      if (params.node.selected) {
        this.currentErrorPaymentRowSelected = params.node.data;

        this.distributeBtnDisabled =
          this.currentErrorPaymentRowSelected.coderr !== "0" ? true : false;
      }
    },
    onErrorPaymentsRowDoubleClicked() {
      this.onClickErrorPaymentChangeBtn("edit");
    },
    onClickErrorPaymentChangeBtn(state) {
      const { payid } = this.currentErrorPaymentRowSelected;

      const payload = {
        state,
        npack: "",
        payid,
        date: "",
        sumPay: 0,
        kindpay: "",
        countpay: 0,
        note: ""
      };
      this.setPaymentData(payload);
      this.setPaymentModal(true);
    },
    onClickErrorPaymentDistributeBtn() {
      const { payid } = this.currentErrorPaymentRowSelected;

      this.clearPaymentPostingError();
      this.$store.dispatch("paymentPostingError", { payid }); // !!! конфликт имен экшена с геттером
    },
    getErrorPayments() {
      if (this.errorPaymentsGridOptions.api) {
        this.errorPaymentsGridOptions.api.setRowData([]);
        this.errorPaymentsGridOptions.api.showLoadingOverlay();
      }

      const perror = "1";
      const {
        abcode,
        abcodeTypeSearch,
        sumPayBegin,
        sumPayEnd,
        sumPayTypeSearch,
        dateBankBegin,
        dateBankEnd,
        dateBankTypeSearch,
        datePayBegin,
        datePayEnd,
        datePayTypeSearch,
        dateChangeBegin,
        dateChangeEnd,
        dateChangeTypeSearch,
        errorType,
        npack,
        datePayFrom,
        datePayTo,
        kindpay,
        codefirme,
        note,
        noteTypeSearch
      } = this.searchErrorPaymentsForm;

      this.$store.dispatch("getPaymentErrors", {
        perror,
        abcode,
        abcodeTypeSearch,
        sumPayBegin: sumPayBegin || 0,
        sumPayEnd: sumPayEnd || 0,
        sumPayTypeSearch,
        dateBankBegin: dateBankBegin || "",
        dateBankEnd: dateBankEnd || "",
        dateBankTypeSearch,
        datePayBegin: datePayBegin || "",
        datePayEnd: datePayEnd || "",
        datePayTypeSearch,
        dateChangeBegin: dateChangeBegin || "",
        dateChangeEnd: dateChangeEnd || "",
        dateChangeTypeSearch,
        errorType: errorType || "",
        npack: npack || "",
        datePayFrom: datePayFrom || "",
        datePayTo: datePayTo || "",
        kindpay: kindpay || "",
        codefirme: codefirme || "",
        note,
        noteTypeSearch
      });
    },
    searchErrorPaymentsModalShow() {
      this.searchErrorPaymentsForm = {
        abcode: "",
        abcodeTypeSearch: "1",
        sumPayBegin: 0,
        sumPayEnd: 0,
        sumPayTypeSearch: "0",
        dateBankBegin: "",
        dateBankEnd: "",
        dateBankTypeSearch: "0",
        datePayBegin: "",
        datePayEnd: "",
        datePayTypeSearch: "0",
        dateChangeBegin: "",
        dateChangeEnd: "",
        dateChangeTypeSearch: "0",
        errorType: null,
        npack: null,
        datePayFrom: "",
        datePayTo: "",
        kindpay: null,
        codefirme: null,
        note: "",
        noteTypeSearch: "1"
      };

      this.extendedSearch = false;
    },
    searchErrorPaymentsModalHide() {
      this.$refs.searchErrorPayments.scrollTo(0, 0);
    },
    searchErrorPaymentsFormSubmit() {
      this.$refs.searchErrorPaymentsForm.validate(valid => {
        if (valid) {
          // проверка незаполненности формы
          const {
            abcode,
            abcodeTypeSearch,
            sumPayBegin,
            sumPayEnd,
            sumPayTypeSearch,
            dateBankBegin,
            dateBankEnd,
            dateBankTypeSearch,
            datePayBegin,
            datePayEnd,
            datePayTypeSearch,
            dateChangeBegin,
            dateChangeEnd,
            dateChangeTypeSearch,
            errorType,
            npack,
            datePayFrom,
            datePayTo,
            kindpay,
            codefirme,
            note,
            noteTypeSearch
          } = this.searchErrorPaymentsForm;

          if (
            abcode === "" &&
            abcodeTypeSearch === "1" &&
            sumPayBegin === 0 &&
            sumPayEnd === 0 &&
            sumPayTypeSearch === "0" &&
            dateBankBegin === "" &&
            dateBankEnd === "" &&
            dateBankTypeSearch === "0" &&
            datePayBegin === "" &&
            datePayEnd === "" &&
            datePayTypeSearch === "0" &&
            dateChangeBegin === "" &&
            dateChangeEnd === "" &&
            dateChangeTypeSearch === "0" &&
            errorType === null &&
            npack === null &&
            datePayFrom === "" &&
            datePayTo === "" &&
            kindpay === null &&
            codefirme === null &&
            note === "" &&
            noteTypeSearch === "1"
          ) {
            this.$confirm(
              this.$t(
                "relationship.searchErrorPaymentsForm.confirm.searchTermNotSpecified"
              ),
              "",
              {
                confirmButtonText: this.$t("common.buttons.confirmYes"),
                cancelButtonText: this.$t("common.buttons.confirmNo"),
                cancelButtonClass: "cancel-button",
                type: "info"
              }
            )
              .then(() => {
                this.$confirm(
                  this.$t(
                    "relationship.searchErrorPaymentsForm.confirm.veryMuchPayments"
                  ),
                  "",
                  {
                    confirmButtonText: this.$t("common.buttons.confirmYes"),
                    cancelButtonText: this.$t("common.buttons.confirmNo"),
                    cancelButtonClass: "cancel-button",
                    type: "warning"
                  }
                )
                  .then(() => {
                    this.searchErrorPaymentsModal = false;
                    this.getErrorPayments();
                  })
                  .catch(() => {});
              })
              .catch(() => {});
          } else {
            this.searchErrorPaymentsModal = false;
            this.getErrorPayments();
          }
        }
      });
    },
    onShortKeyRouter(event) {
      switch (event.srcKey) {
        // Error: F2 Автоматически разнести платеж после изменения
        case "F2":
          if (!this.paymentModal && !this.searchErrorPaymentsModal) {
            this.autoDistributeCheckbox = !this.autoDistributeCheckbox;
            // Error:searchErrorPaymentsModal F2 Расширенный поиск
          } else if (!this.paymentModal && this.searchErrorPaymentsModal) {
            this.extendedSearch = !this.extendedSearch;
          }
          break;
        // Error: F4 Исправить
        case "Enter":
        case "F4":
          if (!this.fixBtnDisabled && !this.paymentModal) {
            this.onClickErrorPaymentChangeBtn("edit");
          }
          break;
        // Error: F7 Поиск платежей
        case "F7":
          if (!this.paymentModal) {
            this.searchErrorPaymentsModal = true;
          }
          break;
        // Error: F9 Разнести
        case "F9":
          if (!this.distributeBtnDisabled && !this.paymentModal) {
            this.onClickErrorPaymentDistributeBtn();
          }
          break;
        // Error:searchErrorPaymentsModal F10 Подтвердить
        case "F10":
          if (!this.paymentModal && this.searchErrorPaymentsModal) {
            this.searchErrorPaymentsFormSubmit();
          }
          break;
        // Error: Del, "-" Удалить
        case "Del":
        case "Minus":
          if (!this.removeBtnDisabled && !this.paymentModal) {
            this.onClickErrorPaymentChangeBtn("del");
          }
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-errors-container-modal {
  margin-top: 10px;
  height: calc(100vh - 210px);
  overflow-y: auto;
}

.grid-errors-container-view {
  margin-top: 10px;
  height: calc(100vh - 171px);
  overflow-y: auto;
}
</style>

<style lang="scss">
.el-input-number .el-input__inner {
  text-align: left;
}
</style>
